module.exports = __webpack_public_path__ + "static/media/amex.f6c13326.svg";